import React from "react";

import { Button } from "antd";

import Styles from "../styles/confirmedShortlist.module.scss";
import styled from "styled-components";

const Heading = styled.p`
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;
  display: flex;
  align-items: center;

  color: #1e2228;
`;

const Top = ({ dataToShow, totalElement, handleExportClick }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: "20px",
      }}
      className={Styles.searchTopWrapper}
    >
      <Heading>{dataToShow.length} Approved Candidate</Heading>

      <div className={Styles.buttonWrapper}>
        <Button
          icon={<img src="/document-upload.svg" />}
          className={`${Styles.export} ${
            dataToShow.length === 0 ? Styles.inactive : ""
          }`}
          disabled={dataToShow.length === 0 ? true : false}
          onClick={handleExportClick}
        >
          Export
        </Button>
      </div>
    </div>
  );
};

export default Top;
